/*!
 * Copyright © 2025 Actavivo
 */

import * as AV from "./Interfaces/AV.Interfaces";
import { Media } from "./Media";

/** Thin helper wrapping an ILink: provides getTummb() to resolve the thumbnail URL via MediaStore, used by AVEntity.getThumb(). */
export class Link {
	public constructor(public data: AV.ILink) {}
	public static getTummb(param: AV.ILink, defaultImg = ""): string {
		if (param?.thumb) return Media.getThumb(param);
		else return defaultImg;
	}
	public getTummb(defaultImg = ""): string {
		if (this.data.thumb) return Media.getThumb(this.data);
		else return defaultImg;
	}
}
